document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ec-calc]').forEach(function (root) {
    var customers = root.querySelector('[data-ec-calc-customers]');
    var price = root.querySelector('[data-ec-calc-price]');
    var mrr = root.querySelector('[data-ec-calc-mrr]');
    var arr = root.querySelector('[data-ec-calc-arr]');

    if (!customers || !price || !mrr || !arr) return;

    function money(value) {
      return '$' + Math.max(0, value).toLocaleString('en-US', {
        maximumFractionDigits: 0
      });
    }

    function update() {
      var customerCount = Math.max(0, Number(customers.value) || 0);
      var monthlyPrice = Math.max(0, Number(price.value) || 0);
      var monthlyRevenue = customerCount * monthlyPrice;

      mrr.textContent = money(monthlyRevenue);
      arr.textContent = money(monthlyRevenue * 12);
    }

    customers.addEventListener('input', update);
    price.addEventListener('input', update);

    update();
  });
});